import { Component, Input } from '@angular/core';

import {  Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { IncludeExcludeModel } from '../../models/include-exclude-model';
import { ControlValueAccessorModel, getProvider } from '../../../Forms/models/control-value-accessor.model';

@Component({
    selector: 'agpr-filter-summary',
    templateUrl: './filter-summary.component.html',
    styleUrls: ['./filter-summary.component.scss'],
    providers: [getProvider(FilterSummaryComponent)],
    standalone: false
})
export class FilterSummaryComponent extends ControlValueAccessorModel<IncludeExcludeModel<any>> {

    @Input() includeExcludeKey: string = null;
    @Input() labelLookupKey: string;
    @Input() labelLookupValue: string = null;
    @Input() labelLookup: (keys: any[]) => Observable<any[]> | Observable<any[]> = null;

    valueLabels: IncludeExcludeModel<String> = new IncludeExcludeModel();

    writeValue(value: IncludeExcludeModel<any>): void {
        if (!value) {
            return;
        }

        let valueAsIncludeExclude: IncludeExcludeModel<any>;

        if (!(value instanceof IncludeExcludeModel)) {
            valueAsIncludeExclude = new IncludeExcludeModel();
            valueAsIncludeExclude.include = value;
        } else {
            if (this.includeExcludeKey) {
                valueAsIncludeExclude = new IncludeExcludeModel();
                valueAsIncludeExclude.include = value.include.map(x => x[this.includeExcludeKey]);
                valueAsIncludeExclude.exclude = value.exclude.map(x => x[this.includeExcludeKey]);
            } else {
                valueAsIncludeExclude = value;
            }
        }

        if (this.labelLookup) {
            let lookupObservable: Observable<any[]>;
            if (!(this.labelLookup instanceof Observable)) {
                if (valueAsIncludeExclude.includeAll && Array.isArray(valueAsIncludeExclude.includeAll)) {
                    lookupObservable = this.labelLookup([
                        ...valueAsIncludeExclude.include,
                        ...valueAsIncludeExclude.exclude,
                        ...valueAsIncludeExclude.includeAll
                    ]);
                } else {
                    lookupObservable = this.labelLookup([...valueAsIncludeExclude.include, ...valueAsIncludeExclude.exclude]);
                }
            } else {
                lookupObservable = this.labelLookup;
            }

            lookupObservable.pipe(
                filter(x => !!x))
                .subscribe(fullObjects => {

                    // To be safe i'll assume the lookup doesn't always return items in the same order
                    this.valueLabels = new IncludeExcludeModel();
                    valueAsIncludeExclude.include.forEach(aValue => {
                        const fullObject = fullObjects.find(obj => obj[this.labelLookupKey] === aValue);
                        if (fullObject) {
                            this.valueLabels.include.push(fullObject[this.labelLookupValue]);
                        }
                    });

                    valueAsIncludeExclude?.includeAll?.forEach(aValue => {
                        const fullObject = fullObjects.find(obj => obj[this.labelLookupKey] === aValue);
                        if (fullObject) {
                            this.valueLabels.includeAll.push(fullObject[this.labelLookupValue]);
                        }
                    });

                    valueAsIncludeExclude.exclude.forEach(aValue => {
                        const fullObject = fullObjects.find(obj => obj[this.labelLookupKey] === aValue);
                        if (fullObject) {
                            this.valueLabels.exclude.push(fullObject[this.labelLookupValue]);
                        }
                    });
                });
        } else {
            // The value is assumed to already be string based
            this.valueLabels = valueAsIncludeExclude;
        }
    }
}

